import { render, staticRenderFns } from "./EipWelcome.vue?vue&type=template&id=6ef29484&"
import script from "./EipWelcome.vue?vue&type=script&lang=js&"
export * from "./EipWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports